export const CorePlanIDs = ['core-monthly', 'core-yearly'];

export default (planID: string) => {
  return CorePlanIDs.includes(planID);
};
